import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function DepositManagementMenuItem(props) {
  const { salonId } = props;

  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.salon.deposit.management(salonId));
  };

  return (
    <MainMenuItem
      itemTitleString="入金を管理する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default DepositManagementMenuItem;
